import React from "react";

const cartContext = React.createContext({
  items: [],
  totalAmount: 0,
  addItem: (item) => {},
  removeItem: (id) => {},
  clearCart:() =>{}
});


export default cartContext ; 


// import React from 'react'

// const cartContext = () => {
//   return (
//     <div>cart-context</div>
//   )
// }

// export default cartContext ;